import {
  ApartmentOutlined,
  DashboardOutlined,
  FlagOutlined,
  GoldOutlined,
  IdcardOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const paths = [
  { path: "/setup-account/general/org-levels", key: "1" },
  { path: "/setup-account/general/designations", key: "2" },
  { path: "/setup-account/general/plan-templates", key: "3" },
  { path: "/setup-account/general/plan-groups", key: "4" },
  { path: "/setup-account/general/plan-attributes", key: "5" },
  { path: "/setup-account/general/scales", key: "6" },
];

function SetupGeneral() {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("3");
      }
    });
  }, [curLocation]);

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <div className="flex">
          <div
            style={{
              height: proHeight - 64,
              overflow: "auto",
            }}
            className="w-48 border-r custom-scroll"
          >
            <div
              className="shadow-sm border-b text-lg pri-font"
              style={{ padding: "14px 24px", backgroundColor: "#fff" }}
            >
              General
            </div>
            <Menu
              className="transparent-scroll"
              mode="inline"
              selectedKeys={[mainKey]}
            >
              <Menu.Item key="1" icon={<ApartmentOutlined />}>
                <Link to="/setup-account/general/org-levels">Org Levels</Link>
              </Menu.Item>
              <Menu.Item key="2" icon={<IdcardOutlined />}>
                <Link to="/setup-account/general/designations">
                  Designations
                </Link>
              </Menu.Item>
              <Menu.Item key="3" icon={<FlagOutlined />}>
                <Link to="/setup-account/general/plan-templates">
                  Plan Templates
                </Link>
              </Menu.Item>
              <Menu.Item key="4" icon={<GoldOutlined />}>
                <Link to="/setup-account/general/plan-groups">Plan Groups</Link>
              </Menu.Item>
              <Menu.Item key="5" icon={<UnorderedListOutlined />}>
                <Link to="/setup-account/general/plan-attributes">
                  Plan Attributes
                </Link>
              </Menu.Item>
              <Menu.Item key="6" icon={<DashboardOutlined />}>
                <Link to="/setup-account/general/scales">Scales</Link>
              </Menu.Item>
            </Menu>
          </div>
          <div className="w-full">
            <Outlet />
          </div>
        </div>
      </Content>
    </>
  );
}

export default SetupGeneral;
